import { inject, Injectable } from "@angular/core";
import { IconResolver } from "@ubisolutions/core";
import { catchError, Observable, of } from "rxjs";
import { ClientSettingsService } from "@shared/business/services/client-settings.service";

/**
 * The client's icon mapping (client settings).
 */
@Injectable()
export class CtIconResolver implements IconResolver {
    private readonly clientSettingsService = inject(ClientSettingsService);

    resolve(key: string): Observable<string> {
        return this.clientSettingsService.getIconForKey(key).pipe(
            catchError(() => of("error_icon")),
        );
    }
}
